import { Component } from 'react';

/**
 * Helper component to show/hide the child component based on the currentScreen.
 */
class Screen extends Component {
  render() {
    if (this.props.current !== this.props.name) {
      return null;
    }

    return this.props.children;
  }
}

export default Screen;



// WEBPACK FOOTER //
// ./src/components/Screen.js